import React, { useEffect, useState } from "react";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, Chip, Grid, Typography } from "@mui/material";
import { fDate, useDateUtils } from "../../../../utils/formatTime";
import { CSVExport } from "../../../components/ui-component/table/CSVExport";

export default function MetaHyperlink({
  detailsData,
  rowData,
  filterType,
  fromDate,
  toDate,
  userWise,
  isDownloadAccess
}) {
  const userRole = localStorage.getItem("userRole");
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];
    const [exportData, setExportData] = useState([]);

  const columns = [
    {
      field: "name",
      headerName: "Enquiry Name",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.first_name || ""}{" "}
    ${params.row?.last_name}`,
      renderCell: (params) => (
        <div>
          {" "}
          <div>
            <Button
              size="small"
              onClick={() =>
                window.open(`/enquirydetails/${params?.row?.id}`, "_blank")
              }
            >
              {params.row?.first_name}{" "}
              {params.row?.last_name ? params.row?.last_name : ""}
            </Button>
          </div>
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "phone",
      headerName: "Mobile",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {" "}
          {params.row?.mobile_country_code}
          {userRole === "advisor" || userRole === "trainer"
            ? params.row?.mobile?.replace(/.(?=.{4,}$)/g, "*")
            : params.row?.mobile}
        </div>
      ),
    },
     {
      field: "email",
      headerName: "Email",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => `${params.row?.email || ""}`,
     
    },
  
    {
      field: "assign_to",
      headerName: "Assign To",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params.row?.assign_to?.first_name || ""}{" "}
    ${params.row?.assign_to?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.assign_to?.first_name} {params.row?.assign_to?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "enquiry_date",
      headerName: "Enquiry Date",

      width: 150,
      headerClassName: "header-cell",

      headerAlign: "center",
      align: "center",
    },

    {
      field: "nearest_branch",
      headerName: "Nearest  Branch",

      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.nearest_branch_id?.branch_name || "",
      renderCell: (params) => (
        <div>{params.row?.nearest_branch_id?.branch_name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

    {
      field: "service",
      headerName: "Service",
      width: 200,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.service_id?.service_name || "",
      renderCell: (params) => <div>{params.row?.service_id?.service_name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "subService",
      headerName: "Sub Service",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.sub_service_id?.name || "",
      renderCell: (params) => <div>{params.row?.sub_service_id?.name}</div>,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "leadSource",
      headerName: "Lead Source",
      width: 100,
      headerClassName: "header-cell",
      valueGetter: (params) => params.row?.lead_source_type_id?.name || "",
      renderCell: (params) => (
        <div>{params.row?.lead_source_type_id?.name}</div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "sublead",
      headerName: "Sub Lead Source",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        params.row?.sub_lead_source_type_id?.source_type || "",
      renderCell: (params) => (
        <div>{params.row?.sub_lead_source_type_id?.source_type}</div>
      ),
      headerAlign: "center",
      align: "center",
    },

   
   
  ];

  // DownLoad Report
    useEffect(() => {
      const exportData = detailsData.map((row) => ({
        name: row?.last_name
          ? `${row?.first_name} ${row?.last_name}`
          : row?.first_name,
        mobile_country_code: row?.mobile_country_code || "",
        mobile: row?.mobile || "",
  
        enquiry_date: fDate(row?.enquiry_date || ""),
  
        nearest_branch: row?.nearest_branch_id?.branch_name || "",
        service: row?.service_id?.service_name,
        sub_service: row?.sub_service_id?.name,
        lead_source: row?.lead_source_type_id?.name,
        sub_lead_source: row?.sub_lead_source_type_id?.source_type,
        prospective_level: row?.prospective_level_id?.prospective_level,
        stage: row?.stage_id?.stage_name,
        branch: row?.branch_id?.branch_name,
        assign_to: `${row?.assign_to?.first_name || ""} ${
          row?.assign_to?.last_name || ""
        }`,
        recycle_by: `${row?.recycleBy_id?.first_name || ""} ${
          row?.recycleBy_id?.last_name || ""
        }`,
        recycle_reason: row?.recycle_reason_id?.recycle_reason,
        recycle_date: fDate(row?.pros_lvl_update_date),
        status: row?.status,
      }));
      setExportData(exportData);
    }, [detailsData]);
  
  return (
    <>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: "flex", flexDirection: "row", gap: 5 }}
        >
        
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Typography variant="h5"> Lead Owner :</Typography>
              <Typography ml={1}>
                {rowData?.first_name} {rowData?.last_name}
              </Typography>
            </Box>
    
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Typography variant="h5" mr={1}>Enquiry Created Date :</Typography>



            {filterType === "today" && (
              <Typography>Today ({currentDate})</Typography>
            )}
            {filterType === "currentweek" && (
              <Typography>This Week ({weekRange})</Typography>
            )}

            {filterType === "currentmonth" && (
              <Typography>
                {currentMonthName} {currentYear}
              </Typography>
            )}

            {filterType === "custom" && (
              <Typography>
                {fromDate} - {toDate}
              </Typography>
            )}
          </Box>
        </Grid>
          <Grid
                        item
                        xs={12}
                        md={6}
                      
                    
                        textAlign='end'
                        gap={1}
                      >

                        {isDownloadAccess && (
                          <CSVExport
                            data={exportData}
                            filename="meta-enquiry-report.csv"
                          />
                        )}
                      </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={detailsData}
            columns={columns}
            autoHeight
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
            disableRowSelectionOnClick
          />
        </Grid>
      </Grid>
    </>
  );
}
